export function initializeTooltips(element?: JQuery<Element>) {
    const tooltipElements = element
        ? $('[data-toggle="tooltip"]', element)
        : $('[data-toggle="tooltip"]');
    //@ts-ignore
    tooltipElements.tooltip({
        trigger: "hover"
    });
    tooltipElements.on("click", function () { // taken from https://stackoverflow.com/a/41031348/379279 - needed to make the tooltip disappear after a click
        //@ts-ignore
        $("div[role=tooltip]").remove();
    });
}
